import {
    Component,
    ViewChild,
    Input,
    ChangeDetectionStrategy,
} from "@angular/core";

import { Strings } from "../app.constants";
import { SimpleToggleableComponent } from "../components/simpleToggleable.component";
import { PersistenceService } from "../store/model/persistence.service";
import { Division } from "../services/consultation.service";
import { DivisionValidity } from "../store/validity/state";
import { createCancellation, createExemption } from "../data/model-utils";
import { ZbdInputComponent } from "../components/zbd-input.component";
import { productsByKey } from "../data/product.constants";

@Component({
    selector: "zbd-recommendation",
    exportAs: "recommendation",
    templateUrl: "recommendation.component.html",
    styleUrls: ["./recommendation.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationComponent {
    @ViewChild(SimpleToggleableComponent) toggleable: SimpleToggleableComponent;

    @Input() persistence: PersistenceService;
    @Input() division: Division;
    @Input() validity: DivisionValidity;

    strings = Strings;
    productsByKey = productsByKey;

    public addCancellation(division: Division) {
        return () => {
            this.persistence.addRecommendation_RecommendedCancellations(
                division.Recommendation,
                createCancellation(),
            );
        };
    }

    public addExemption(division: Division) {
        return () => {
            this.persistence.addRecommendation_RecommendedExemptions(
                division.Recommendation,
                createExemption(),
            );
        };
    }
}
